<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-100">
      <edit-form ref="edit-form" header-color="green"> </edit-form>
    </div>
  </div>
</template>
<script>
import EditForm from "./DormUpdateComponent/DormEditForm";

export default {
  components: {
    EditForm
  },
  mounted() {
    this.dormID = this.$route.params.id;
    this.$store.getDorm(this.dormID).then(response => {
      this.$refs["edit-form"].name = response.data.name;
      this.$refs["edit-form"].address = response.data.address;
      // this.$refs["edit-form"].main_user = response.data.main_user
      // this.$refs["edit-form"].country = response.data.country
      // this.$refs["edit-form"].end_date = response.data.end_date
      // this.$refs["edit-form"].email = response.data.email
      // this.$refs["edit-form"].phone = response.data.phone
      this.$refs["edit-form"].lat = response.data.lat;
      this.$refs["edit-form"].long = response.data.long;
      // Status
      if (response.data.status === "Full Active") {
        this.$refs["edit-form"].status = 1;
      } else if (response.data.status === "Active") {
        this.$refs["edit-form"].status = 2;
      } else if (response.data.status === "Inactive") {
        this.$refs["edit-form"].status = 3;
      }
    });
  }
};
</script>
